import styled from 'styled-components';

const TeamFormStyle = styled.div`
	&.teamFormCont {
		--sectionMarg: var(--sp8x);
		--inputMargTop: var(--sp4x);
		--inputMargBottom: var(--sp1x);
		--checkboxBottom: var(--sp3x);

		.successMessageCont {
			display: flex;
			justify-content: flex-end;
			padding-left: var(--contPadLeft);
			margin-top: var(--sectionMarg);

			.successMessage {
				position: relative;
				display: flex;
				flex-direction: column;
				max-width: var(--sectionInfoMaxWidth);
				padding-top: var(--sp5x);

				.msg {
					position: absolute;
					top: 0;
					left: 0;
				}

				.animCont {
					max-width: 40%;
					margin-right: 20%;
					margin-top: var(--sp3x);
					align-self: flex-end;
					mix-blend-mode: difference;
				}
			}
		}

		.TeamFormWrap {
			margin-top: var(--titleToContent);
			padding-left: var(--contPadLeft);

			.rowTitleContClassName {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				margin-bottom: var(--sectionMarg);

				.rowTitleClassName {
					opacity: 0;
					flex: var(--sectionTitleMaxWidth);
					max-width: var(--sectionTitleMaxWidth);
					margin-bottom: var(--sp4x);

					font-weight: var(--ffLight);
					font-size: var(--pM);
					font-family: var(--fontFamily2);

					~ div {
						opacity: 0;
						width: 100%;
						max-width: var(--sectionInfoMaxWidth);
					}
				}

				// .successMessage {
				//     position: absolute;
				//     top: 0;
				//     left: 0;
				//     right: 0;
				//     bottom: 0;
				//     display: flex;
				//     align-items: center;
				//     justify-content: center;
				//     color: var(--color1);
				//     background-color: var(--color2);
				//     z-index: 14;
				//     text-align: center;
				// }

				.inputWrapClass {
					margin-bottom: var(--inputMargTop);
					position: relative;

					&:last-child {
						margin-bottom: 0;
					}

					.inputClass {
						overflow: hidden;

						input {
							padding-bottom: var(--inputMargBottom);
							width: 100%;
							height: 100%;
							background-color: transparent;
							border: unset;
							font-size: var(--pM);
							font-family: var(--fontFamily2);
							font-weight: var(--ffLight);
							color: var(--color1);

							&::placeholder {
								color: var(--color1);
								font-size: var(--pM);
							}

							&:focus {
								outline: 0;
							}
						}

						svg {
							bottom: 0;
							height: 100%;
							stroke: var(--color1);
						}
					}

					.textareaClassName {
						overflow: hidden;

						textarea {
							font-size: var(--pM);
							font-family: var(--fontFamily2);
							font-weight: var(--ffLight);
							color: var(--color1);

							&::placeholder {
								color: var(--color1);
								font-size: var(--pM);
							}
						}

						svg {
							bottom: 0;
							max-height: 50px;
							stroke: var(--color1);
						}
					}
				}
			}

			@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
				--inputMargTop: var(--sp5x);
				--inputMargBottom: var(--sp1-5x);
			}

			@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
				--inputMargTop: var(--sp6x);
				--inputMargBottom: var(--sp2x);
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
				--sectionMarg: var(--sp10x);
				--inputMargTop: var(--sp6x);
				--inputMargBottom: var(--sp2x);
			}

			@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			}

			@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
				--sectionMarg: var(--sp15x);
				--inputMargTop: var(--sp8x);
				--inputMargBottom: var(--sp2x);
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
				--sectionMarg: var(--sp20x);
				--inputMargTop: var(--sp9x);
				--inputMargBottom: var(--sp2x);
			}
		}
	}
`;

export default TeamFormStyle;
